import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";

const ButtonUpload = (props) => {
  const { files, setFiles, maxFileSize, multiple, accept, ...otherProps } = props;
  // const [files, setFiles] = useState([]);

  const validate = (file) => {
    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
    ];
    return allowedTypes.includes(file.type) && file.size <= maxFileSize;
  };

  const _input = useRef();
  const handleClick = () => _input.current.click();
  // const handleClick = () => {
  //   let fileInputElement = document.createElement("input");
  //   fileInputElement.style.display = "none";
  //   fileInputElement.setAttribute("type", "file");
  //   fileInputElement.setAttribute("accept", accept.join(","));
  //   document.body.appendChild(fileInputElement);
  //   fileInputElement.click();
  //   document.body.removeChild(fileInputElement);
  // };

  const handleChange = (event) => {
    // event.preventDefault();
    console.log(event.target.files);
    if (![...event.target.files].map((f) => validate(f)).includes(false)) {
      setFiles([...files, ...event.target.files]);
    }
    // _input.current.replaceWith(_input.current.val("").clone(true));
    // _input.current
  };

  return (
    <>
      <Button {...otherProps} onClick={handleClick} />
      <input
        ref={_input}
        type="file"
        accept={accept.join(",")}
        multiple={multiple}
        style={{ display: "none" }}
        onChange={handleChange}
      />
    </>
  );
};

export default ButtonUpload;

ButtonUpload.defaultProps = {
  maxFileSize: 10000000, // 10MB
  accept: [".png", ".jpg", ".pdf", ".docx", ".xlsx", ".csv"],
  multiple: false,
};

ButtonUpload.propTypes = {
  maxFileSize: PropTypes.number,
  accept: PropTypes.arrayOf(PropTypes.string),
  multiple: PropTypes.bool,
};

// const ele = document.createElement("input");
// ele.style.display = "none";
// ele.setAttribute("type", "file");
// ele.setAttribute("multiple", multiple);
// ele.setAttribute("accept", accept.join(","));
// ele.setAttribute("onChange", handleChange);
// console.log(ele);
// document.body.appendChild(ele);
// ele.click();
// document.body.removeChild(ele);
